module.exports = __webpack_public_path__ + "3427ffb8634ac8e33e74df38f37d8b9a.jpg";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/singing-spear-video-poster.jpg
// module id = 529
// module chunks = 0